import React, { useState } from 'react';
import { apiUrl } from '../services/api';

// Live flight status for a single leg via the optional AeroDataBox integration.
// Renders nothing if there's no flight number; shows a hint if the backend key
// (RAPIDAPI_KEY) isn't configured.
export default function FlightStatus({ flightNumber, date, label }) {
  const [loading, setLoading] = useState(false);
  const [flights, setFlights] = useState(null);
  const [notConfigured, setNotConfigured] = useState(false);

  if (!flightNumber) return null;

  const check = async () => {
    setLoading(true);
    setNotConfigured(false);
    try {
      const params = new URLSearchParams({ flight: flightNumber, date: date || '' });
      const res = await fetch(apiUrl(`/api/flights/status?${params.toString()}`));
      const data = await res.json();
      if (!data.configured) { setNotConfigured(true); setFlights(null); return; }
      setFlights(Array.isArray(data.flights) ? data.flights : []);
    } catch {
      setFlights([]);
    } finally {
      setLoading(false);
    }
  };

  const muted = { fontSize: 12, color: 'var(--tp-muted)', marginLeft: 8 };

  return (
    <div style={{ marginTop: 8 }}>
      <button type="button" className="tp-btn--ghost" onClick={check} disabled={loading}>
        {loading ? 'Checking…' : `✈ Live status${label ? ` (${label})` : ''}`}
      </button>
      {notConfigured && <span style={muted}>Set RAPIDAPI_KEY on the backend to enable live flight status.</span>}
      {Array.isArray(flights) && flights.length === 0 && !notConfigured && (
        <span style={muted}>No live status found for {flightNumber} on {date || 'that date'}.</span>
      )}
      {Array.isArray(flights) && flights.map((f, i) => (
        <div key={i} style={{ fontSize: 13, marginTop: 4 }}>
          <strong>{f.status || 'Unknown'}</strong>
          {f.departure?.airport && <> · Dep {f.departure.airport}</>}
          {f.departure?.terminal && <> T{f.departure.terminal}</>}
          {f.departure?.gate && <> gate {f.departure.gate}</>}
          {f.departure?.revised && <> · revised {f.departure.revised}</>}
          {f.arrival?.airport && <> → Arr {f.arrival.airport}</>}
          {f.aircraft && <span style={{ color: 'var(--tp-muted)' }}> · {f.aircraft}</span>}
        </div>
      ))}
    </div>
  );
}
